<template>
  <div class="animated fadeIn CreditMemos--CreditMemos-list">
    <div class="card">
      <div class="card-body">
        <div class="d-flex justify-content-start align-items-end mb-2" style="display: none">
          <b-form-group label="Assigned To" class="mr-2">
            <b-form-select @change="onSearch" v-model="filtersObj.assignedTo" :disabled="!checkClaim(CAN_MANAGE_TASKS)">
              <option :value="null">All</option>
              <option v-for="(select, index) in sortSelect(getAllUser,'fullName')" :key="index" :value="select.id">
                {{ select.fullName }}
              </option>
            </b-form-select>
          </b-form-group>
          <b-form-group label="Status" class="mr-2">
            <b-form-select @change="onSearch" v-model="filtersObj.statusId">
              <option :value="null">All</option>
              <option v-for="(select, index) in sortSelect(taskStatusType)" :key="index" :value="select.id">
                {{ select.name }}
              </option>
            </b-form-select>
          </b-form-group>
          <date-range-picker ref="dateRangePicker" :handleSearch="search"></date-range-picker>
          <div class="clear-filter-button-container mr-2">
            <b-button size="sm" @click="onClear">Clear filters</b-button>
          </div>
          <b-button size="sm" variant="primary" @click="openTodoModal(true)">
            <i class="fa fa-plus" aria-hidden="true"></i> Add Task
          </b-button>
        </div>
        <grid-component
          isResizable
          isReorderable
          isSortable
          :navigationField="'subject'"
          :gridId="gridId"
          :itemData="itemData"
          :fields="fields"
          :pageable="pageable"
          :sortBy="pageInfo.sortBy"
          :sortOrder="pageInfo.sortOrder"
          :sortMethod="sortGrid"
          :onEdit="onEdit"
          :onDelete="onDelete"
        />
      </div>
    </div>
    <add-task :editDetails="editDetails" fromCompanyPage @refreshGrid="onClear(true)"/>
    <CloseTask :taskDetails="taskDetails" @refreshGrid="onClear"/>
    <b-modal size="lg" id="task-details-modal" title="Task Detail">
      <TaskDetail v-if="taskDetails.id" :assignedUsers="getAllUser" :taskDetails="taskDetails"
                  @refreshGrid="onClear(true)" @openTodoModal="openTodoModal"/>
    </b-modal>
  </div>
</template>

<script>
  import { mapState, mapActions, mapGetters, mapMutations } from 'vuex';
  import debounce from 'lodash/debounce';
  import { SORT_ORDER, GRID_PAGE_SIZES, PAGE_SIZE, GRID_ID, TODO_TASK_TYPES } from '@/shared/constants';
  import GridSettings from '@/shared/components/GridSettings';
  import GridComponent from '@/shared/components/GridComponent';
  import gridFields from '@/pages/Todotasks/fields';
  import FixedHeader from '@/shared/components/FixedHeader/index';
  import DateRangePicker from '@/shared/components/DateRangePicker';

  const SEARCH_DEBOUNCE_TIME = 750;
  import TaskDetail from '@/pages/Todotasks/components/detail';
  import AddTask from '@/pages/Todotasks/components/add';
  import CloseTask from '@/pages/Todotasks/components/close';
  import { roleMixin } from '@/shared/helpers';

  export default {
    components: {
      GridSettings,
      GridComponent,
      FixedHeader,
      TaskDetail,
      AddTask,
      CloseTask,
      DateRangePicker,
    },
    props: {
      companyId: {
        type: [String, Number],
        default: 0,
      },companyName: {
        type: [String],
        default: '',
      },contactId: {
        type: [String, Number],
        default: 0
      },salesRep: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        fields: gridFields,
        gridId: GRID_ID.TODO_TASKS_GRID,
        pageable: {
          pageSizes: GRID_PAGE_SIZES,
        },
        selectedRowItemId: 0,
        taskTypes: TODO_TASK_TYPES,
        taskDetails: {},
        editDetails: {},
        taskStatusType: [{ id: 410, name: 'Open' }, { id: 411, name: 'Close' }],
        filterPageName: 'companyContactsTodoListPage',
      };
    },
    computed: {
      ...mapGetters('todotasks', [
        'gridList',
        'pageInfo',
        'filters',
        'selectedItemId',
        'tblLoader',
      ]),
      ...mapGetters('account', ['gridSettingsById', 'userId']),
      ...mapState('users', ['getAllUser']),
      itemData() {
        if (this.gridList == undefined || this.gridList.length === 0) return [];
        return this.gridList.map((task) => ({ ...task, selected: task.id === this.selectedRowItemId }));
      },
      filtersObj() {
        return this.filters[this.filterPageName] || {}
      },
    },
    methods: {
      ...mapActions('todotasks', ['getAll', 'sortGrid', 'getPage', 'search', 'deleteTask', 'clearFilters']),
      ...mapActions('users', { 'getAllUserList': 'getAll' }),
      ...mapActions('account', ['saveGridSettings']),
      ...mapMutations('todotasks', ['setItem']),
      gridSettings() {
        return this.gridSettingsById(this.gridId);
      },
      onSearch: debounce(function() {
        this.selectedRowItemId = 0;
        if (!roleMixin.methods.checkClaim(roleMixin.data().CAN_MANAGE_TASKS)) {
          this.filtersObj.assignedTo = this.userId;
        }
        this.filtersObj.companyId = this.companyId;
        this.search({'filters':this.filtersObj,page:this.filterPageName});
      }, SEARCH_DEBOUNCE_TIME),
      onClear(callSearch = true) {
        /*this.clearFilters();*/
        Object.keys(this.filtersObj).forEach(filterName => {
          this.filtersObj[filterName] = null;
        });

        if (!roleMixin.methods.checkClaim(roleMixin.data().CAN_MANAGE_TASKS)) {
          this.filtersObj.assignedTo = this.userId;
        }
        this.filtersObj.companyId = this.companyId;
        if (this.contactId != 0) {
          this.filtersObj.contactId = this.contactId;
        }
        this.$refs.dateRangePicker.setDateRangeAll(); //Clear date range picker
        if (callSearch) {
          this.search({'filters':this.filtersObj,page:this.filterPageName});
        }
      },
      findIconClass(taskTypeId) {
        if (taskTypeId) {
          const myData = this.taskTypes.find(obj => {
            return (obj.id == taskTypeId);
          });
          return myData.icon;
        }
      },
      onEdit(row) {

        console.log('row ::', row);

        this.selectedRowItemId = row.id;
        this.taskDetails = row;
        this.$bvModal.show('task-details-modal');
      },
      async onDelete(task) {   
        const deleteConfirmed = await this.openConfirmBox({message: `Are you sure you want to delete the task, ${task.subject}?`});
        if (deleteConfirmed) {
          await this.deleteTask(task.id);
          this.getAll({});
        }
      },
      openTodoModal(isAdd = false) {
        if (isAdd) {
          this.editDetails = {};
          this.editDetails.companyId = this.companyId;
          this.editDetails.companyName = this.companyName;
          this.editDetails.contactId = this.contactId;
          this.editDetails.assignedToUserId = this.salesRep
          this.$bvModal.show('add-task-modal');
        } else {

          console.log('i');

          /*this.editDetails = this.todotasks.find(obj => {
            return (obj.id === this.selectedRowItemId);
          });
          if (this.editDetails) {
            setTimeout(() => {
              this.$bvModal.show('add-task-modal');
            }, 1000);
          }*/
          // let editTodoDetails = this.todotasks.find(obj => {
          //   return (obj.id === this.selectedRowItemId);
          // });
          if (this.taskDetails && this.taskDetails.id == this.selectedRowItemId) {
            this.editDetails = Object.assign({}, this.taskDetails)
            setTimeout(() => {
              this.$bvModal.show('add-task-modal');
            }, 1000);
          }

        }
      },
      /*async onGetData(params) {
        await this.getcreditMemos(params);
        this.skip = params.pageSize * (params.pageNumber - 1);
        this.take = params.pageSize;
      },*/

    },
    watch: {
      /*gridList() {
        if (this.gridList.length > 0 && this.selectedRowItemId === 0) {
          this.selectedRowItemId = this.gridList[0].id;
          this.taskDetails = this.gridList[0];
        } else if (this.selectedRowItemId) {
          this.taskDetails = this.gridList.find(obj => {
            return (obj.id === this.selectedRowItemId);
          });
        }
      },*/
      getAllUser() {
        if (!roleMixin.methods.checkClaim(roleMixin.data().CAN_MANAGE_TASKS)) {
          this.filtersObj.assignedTo = this.userId;
        }
      },
      companyId() {
        this.setItem({ resource: `filters[${this.filterPageName}]`, payload: { companyId: this.companyId }});  
      },
      filters() {
        this.getAll({});
      }
    },
    mounted() {
      this.setItem({ resource:'filterPage', payload: this.filterPageName });
      this.setItem({ resource: `filters[${this.filterPageName}]`, payload: { companyId: this.companyId }});
      /*this.onSearch();*/
      this.onClear(true);
      // this.skip = this.pageInfo.pageNumber * this.pageInfo.pageSize - 1;
      // this.take = this.pageInfo.pageSize;
      // if (!roleMixin.methods.checkClaim(roleMixin.data().CAN_MANAGE_TASKS)) {
      //   this.filters.assignedTo = this.userId;
      // }
      // // this.filters.companyId = this.companyId;
      // // this.filters.assignedTo = this.userId;
      // // this.filters.statusId = 410;
      // // this.getTaskList();
      // // this.getAllUserList();
    },
  };
</script>
